import {lazy} from '@aboutyou/lazy-imports';
import {CategoryStreamSkeletonMobile} from '@aboutyou/logic-components';
import React from 'react';

export const CouponLandingPageSwitch = lazy(
  () =>
    import('./CouponLandingPageSwitch.eager').then(mod => ({
      default: mod.CouponLandingPageSwitch,
    })),
  {
    fallback: <CategoryStreamSkeletonMobile />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
